import classNames from "classnames";
import { useState } from "react";

// Fallback if image fails to load
const fallback =
  process.env.REACT_APP_NO_IMAGE_AVAILABLE_LOGO ||
  "https://sandbox.densndente.ca/SSP%20Applications/NetSuite%20Inc.%20-%20SCS/SuiteCommerce%20Standard/home-page/no-image-available.png";

export default function Image({ src, alt, className = "", ...props }) {
  // Remember which src failed rather than overwriting the current one, so a new
  // `src` prop is always honoured — carousels and route changes reuse the same
  // element position, and holding the resolved URL in state would freeze the
  // first image that ever loaded.
  const [failedSrc, setFailedSrc] = useState(null);

  const resolvedSrc = !src || failedSrc === src ? fallback : src;

  return (
    <img
      src={resolvedSrc}
      alt={alt}
      className={classNames(className)}
      onError={() => setFailedSrc(src)}
      {...props}
    />
  );
}
